import { useI18n } from '@affine/i18n';
import { useEffect } from 'react';

import { updateBootSplashProgress } from '../../../bootstrap/boot-splash';
import type { WorkspaceEntryLoadState } from './use-workspace-entry-load';
import { SyncProgressBar } from './workspace-sync-dialog';
import * as styles from './workspace-sync-dialog.css';

export function WorkspaceEntryLoading({
  entryLoad,
}: {
  entryLoad: WorkspaceEntryLoadState;
}) {
  const t = useI18n();
  const hasDocProgress =
    entryLoad.loadedDocs !== undefined && entryLoad.totalDocs !== undefined;
  const progressLabel = hasDocProgress
    ? t.t('com.streamlain.workspace.entryLoad.progress', {
        loaded: entryLoad.loadedDocs,
        total: entryLoad.totalDocs,
      })
    : t.t('com.streamlain.workspace.entryLoad.preparing');

  useEffect(() => {
    if (!entryLoad.isLoading) return;
    updateBootSplashProgress({
      label: t.t('com.streamlain.workspace.entryLoad.title'),
      detail: progressLabel,
      progress:
        entryLoad.progress === undefined
          ? undefined
          : 0.62 + entryLoad.progress * 0.36,
    });
  }, [entryLoad.isLoading, entryLoad.progress, progressLabel, t]);

  if (!entryLoad.isLoading) {
    return null;
  }

  return (
    <div className={styles.entryLoadShell}>
      <div className={styles.entryLoadPanel}>
        <div className={styles.entryLoadTitle}>
          {t.t('com.streamlain.workspace.entryLoad.title')}
        </div>
        <div className={styles.entryLoadDescription}>
          {t.t('com.streamlain.workspace.entryLoad.description')}
        </div>
        <SyncProgressBar progress={entryLoad.progress} />
        <div className={styles.progressMeta}>{progressLabel}</div>
      </div>
    </div>
  );
}
